import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import { setEndDate, setStartDate } from 'store/entities/submissions';

import {
  Control,
  Datepicker,
  Field,
  Label,
} from 'components/UIComponents/Form';
import { Column } from 'components/UIComponents/Layout';
import {addYears, endOfYear} from "date-fns";


const DateFilters = () => {
  const { t } = useTranslation();
  const language = useCurrentLanguage();
  const dispatch = useDispatch();

  const { startDate, endDate, submissionsListLoading } = useSelector(
    state => state.submissions
  );

  return (
    <>
      <Column size={6} fullhd={{ size: 2 }}>
        <Field>
          <Control>
            <Label htmlFor="dateFromSelect">
              {t('datagate.external.submissions.filter.from.label')}
            </Label>
            <Datepicker
              disabled={submissionsListLoading}
              id="dateFromSelect"
              locale={language}
              placeholderText={t(
                'datagate.external.submissions.filter.from.placeholder'
              )}
              minDate={new Date(2024, 0, 1)}
              maxDate={endDate}
              selected={startDate}
              onChange={value => dispatch(setStartDate(value))}
            />
          </Control>
        </Field>
      </Column>
      <Column size={6} fullhd={{ size: 2 }}>
        <Field>
          <Control>
            <Label htmlFor="dateToSelect">
              {t('datagate.external.submissions.filter.to.label')}
            </Label>
            <Datepicker
              disabled={submissionsListLoading}
              id="dateToSelect"
              locale={language}
              placeholderText={t(
                'datagate.external.submissions.filter.to.placeholder'
              )}
              selected={endDate}
              minDate={startDate}
              maxDate={endOfYear(addYears(new Date(),1))}
              onChange={value => dispatch(setEndDate(value))}
            />
          </Control>
        </Field>
      </Column>
    </>
  );
};

export default DateFilters;
